import React, { useEffect, useState } from 'react';
import css from './cappa-components.module.css';
import Icon from '../../../components/Icon/Icon';
import { FormattedMessage } from 'react-intl';
import { findRouteByRouteName } from '../../../util/routes';
import { useRouteConfiguration } from '../../../context/routeConfigurationContext';
import { Link } from 'react-router-dom';
import GeocoderGoogleMaps from '../../../components/LocationAutocompleteInput/GeocoderGoogleMaps';

const defaultLocation =
  'bounds=70.27136381%2C-65.96768192%2C-7.15309963%2C-129.42471317&mapSearch=true';
const defaultCategory = 'pub_categoryLevel1=doula';

const urls = {
  defaultEmpty: ``,
  lactationSupport: `&pub_services=lactation_support`,
  virtualDoulaSupport: `&pub_services=virtual_doula_support`,
  newbornCare: `&pub_services=newborn_care`,
  postpartumDoulaSupport: `&pub_services=postpartum_doula_support`,
  birthDoulaSupport: `&pub_services=birth_doula_support`,
};

const LandingServicesSection = () => {
  const [currentLocation, setCurrentLocation] = useState(defaultLocation);
  const bigPregancyText = (
    <FormattedMessage
      id="LandingPage.cappaComponents.bigPregancyText"
      defaultMessage={'Birth doula support'}
    />
  );
  const bigHeartCareText = (
    <FormattedMessage
      id="LandingPage.cappaComponents.bigHeartCareText"
      defaultMessage={'Postpartum doula support'}
    />
  );
  const bigNewBornChildText = (
    <FormattedMessage
      id="LandingPage.cappaComponents.bigNewBornChildText"
      defaultMessage={'Newborn care'}
    />
  );
  const bigCallcenterText = (
    <FormattedMessage
      id="LandingPage.cappaComponents.bigCallcenterText"
      defaultMessage={'Virtual doula support'}
    />
  );
  const bigLactationText = (
    <FormattedMessage
      id="LandingPage.cappaComponents.bigLactationText"
      defaultMessage={'Lactation support'}
    />
  );
  const bigOtherText = (
    <FormattedMessage id="LandingPage.cappaComponents.bigOtherText" defaultMessage={'Others'} />
  );

  const getCurrentLocation = async () => {
    new GeocoderGoogleMaps()
      .getPlaceDetails(
        {
          id: 'current-location',
          predictionPlace: {},
        },
        1000
      )
      .then(place => {
        console.log(place);
        setCurrentLocation(`bounds=${place.origin.lat}%2C${place.origin.lng}&mapSearch=true`);
      })
      .catch(e => {
        console.error(e);
      });
  };

  useEffect(() => {
    // getCurrentLocation();
  }, []);

  return (
    <div className={css.serviceRoot}>
      <div className={css.serviceWrapper}>
        <ServiceCard
          icon={<Icon icon="BigPregnacy" className={css.serviceCardIcon} size={null} />}
          text={bigPregancyText}
          url={urls.birthDoulaSupport}
          currentLocation={currentLocation}
        />
        <ServiceCard
          icon={<Icon icon="BigHeartCare" className={css.serviceCardIcon} size={null} />}
          text={bigHeartCareText}
          url={urls.postpartumDoulaSupport}
          currentLocation={currentLocation}
        />
        <ServiceCard
          icon={<Icon icon="BigNewBornChild" className={css.serviceCardIcon} size={null} />}
          text={bigNewBornChildText}
          url={urls.newbornCare}
          currentLocation={currentLocation}
        />
        <ServiceCard
          icon={<Icon icon="BigCallcenter" className={css.serviceCardIcon} size={null} />}
          text={bigCallcenterText}
          url={urls.virtualDoulaSupport}
          currentLocation={currentLocation}
        />
        <ServiceCard
          icon={<Icon icon="BigLactation" className={css.serviceCardIcon} size={null} />}
          text={bigLactationText}
          url={urls.lactationSupport}
          currentLocation={currentLocation}
        />
        <ServiceCard
          icon={<Icon icon="BigOther" className={css.serviceCardIcon} size={null} />}
          text={bigOtherText}
          url={urls.defaultEmpty}
          currentLocation={currentLocation}
        />
      </div>
    </div>
  );
};

const ServiceCard = ({ icon, text, url, currentLocation }) => {
  const routeConfiguration = useRouteConfiguration();
  const onOver = () => {
    const { component: Page } = findRouteByRouteName('SearchPage', routeConfiguration);
    if (Page.preload) {
      Page.preload();
    }
  };

  return (
    <Link
      onMouseOver={onOver}
      onTouchStart={onOver}
      to={{
        pathname: '/s',
        search: `?${currentLocation}&${defaultCategory}${url}`,
      }}
    >
      <div className={css.serviceCard}>
        <div className={css.serviceCardForwardIcon}>
          <Icon icon="CircledArrowRight" size={24} />
        </div>
        <div className={css.serviceCardIcon}>{icon}</div>
        <div className={css.serviceCardText}>{text}</div>
      </div>
    </Link>
  );
};

export default LandingServicesSection;
